import _ from '@lodash';
import TablePagination from '@fuse/components/general/TablePagination';
import Typography from '@material-ui/core/Typography';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FuseLoading from '@fuse/core/FuseLoading';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ListView from './listView';
import GridView from './gridView';
import useRouter from '@fuse/hooks/useRouter';

const useStyles = makeStyles({
	layoutRoot: {},
	head: {
		position: "sticky",
		top: 0
	},
	root: {
		// minWidth: 275,
	},
	title: {
		fontSize: 14,
	},
	pos: {
		marginBottom: 12,
	},
});

function EndUsersAccountsTable(props) {
  const classes = useStyles();
	const [page, setPage] = useState(0);
	const router = useRouter();
	const default_value = Object.keys(router.query).length !== 0 ? props.endUsersAccounts.length : 10;
	const [ rowsPerPage, setRowsPerPage ] = useState(props.endUsersAccounts.length)
	const [loading, setLoading] = useState(false);
	let endUsersAccountsMod = props.endUsersAccounts
		.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

	function handleChangePage(event, value) {
		setPage(value);
	}

	function handleChangeRowsPerPage(event) {
		setPage(0);	
		setRowsPerPage(event);
	}

	useEffect(()=>{
		setRowsPerPage(props.endUsersAccounts.length)
		setPage(0)
	},[props.endUsersAccounts.length])
	
	if(loading){
		return (<FuseLoading/>)
	}

	if (!props.viewLocationPermission) {
		return (
			<div>
				<Card>
					<CardContent>You don't have permission to view any Locations at this time. Please contact your Systems Administrator for access.</CardContent>
				</Card>
			</div>
		)
	}

	if(endUsersAccountsMod.length <= 0){
		return (
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1, transition: { delay: 0.1 } }}
				className="flex flex-1 items-center justify-center h-full"
			>
				<div style={{height: "200px"}}>
					<Typography variant="body2" component="p" color="textSecondary">
						No data found
					</Typography>
				</div>
			</motion.div>
		)
	}

	return (
		<div className="w-full flex flex-col">
			
			{/* <motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1, transition: { delay: 0.1 } }}
				className="flex flex-1 items-center justify-end h-full"
			>
				<Button
				color="primary"
					onClick={()=>props.openAddAttributeDialog(props.platformModuleId)}
				>
					Add field
				</Button>
			</motion.div> */}

			<SwitchView 
				selectedView={props.selectedView} 
				endUsersAccounts={endUsersAccountsMod} 
				refresh={props.refresh} 
				gotoDetailsPage={props.gotoDetailsPage}
				addLocationPermission = {props.addLocationPermission}
				viewLocationPermission = {props.viewLocationPermission}
				updateLocationPermission = {props.updateLocationPermission}
				deleteLocationPermission = {props.deleteLocationPermission}
			/>			
			{/* <div className={`p-10`} style={{width: '100%'}}>
				<TablePagination
					page={page}
					component="div"
					count={props.endUsersAccounts.length}
					onChangePage={handleChangePage}
					rowsPerPage={rowsPerPage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
      </div> */}
		</div>
	);

}

function SwitchView({
	endUsersAccounts,
	selectedView,
	gotoDetailsPage,
	viewPermission,
	refresh,
	addLocationPermission,
	viewLocationPermission,
	updateLocationPermission,
	deleteLocationPermission
}) {

	// if(!viewPermission){
	// 	return(
	// 		<div style={{margin: '20px'}}>
	// 			You don't have the permission
	// 		</div>
	// 	)
	// }

	if(selectedView == 0){
		return(
			<ListView 
				endUsersAccounts={endUsersAccounts} 
				refresh={refresh} 
				gotoDetailsPage={gotoDetailsPage}
				addLocationPermission = {addLocationPermission}
				viewLocationPermission = {viewLocationPermission}
				updateLocationPermission = {updateLocationPermission}
				deleteLocationPermission = {deleteLocationPermission}	
			/>
		)
	}else{
		return(
			<GridView 
				endUsersAccounts={endUsersAccounts}
				gotoDetailsPage={gotoDetailsPage}
			/>
		)		
	}
}

export default withRouter(EndUsersAccountsTable)
